import createPage from '../create-page'
import Artist from './artist'

export default createPage(Artist, 'ARTIST', true)



// WEBPACK FOOTER //
// ./src/components/artist-page/index.js